// utils/roles.js
// 受限角色约定。roleId 由登录响应返回，存于 sessionStorage（见 store/modules/user.js）。
// UI 的隐藏/跳转只是体验层——真正的边界是服务端 ActionFunction 的 403
//（见 Digi-SFT-Server/tools/seed_rtu_user_role.sql 与 rtu_role_403_matrix.py）。

export const RTU_USER_ROLE_ID = 9;

// RTU User 允许访问的路由（前缀匹配）
export const RTU_USER_ALLOWED_ROUTES = [
  '/clientMain/rtuStatus',
  '/clientMain/rtuDashboard',
  '/clientMain/accounts',
];

export const currentRoleId = () => Number(sessionStorage.getItem('roleId') || 0);

export const isRtuUser = () => currentRoleId() === RTU_USER_ROLE_ID;

export const isRouteAllowedForRtuUser = (path) =>
  RTU_USER_ALLOWED_ROUTES.some((p) => path === p || path.startsWith(p + '?'));
